import { InstanceTypeOf } from '@/type-utils';
import { errorFactory } from '../error-utils';

export const { AbortedRequestError } = errorFactory('AbortedRequestError');

/**
 * An error to use when a request is aborted via an AbortController.
 */
export type AbortedRequestError = InstanceTypeOf<typeof AbortedRequestError>;
